import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import CalcSelectionModal from './CalcSelectionModal/index.vue'
import CIcms from './CIcms/index.vue'
import CIssPis from './CIssPis/index.vue'
import CPisIss from './CPisIss/index.vue'
import CPisIcms from './CPisIcms/index.vue'
import CPis from './CPis/index.vue'
import CIss from './CIss/index.vue'
import CCide from './CCide/index.vue'
import CPerse from './CPerse/index.vue'
import CJovem from './CJovem/index.vue'
import CServicosHospitalares from './CServicosHospitalares/index.vue'
import CJcp from './CJcp/index.vue'
import CJcpTlp from './CJcpTlp/index.vue'
import CPat from './CPat/index.vue'
import CRemuneracaoAdm from './CRemuneracaoAdm/index.vue'
import CCreditosPisCofins from './CCreditosPisCofins/index.vue'
import CTransacaoNaoPrevidenciario from './CTransacaoNaoPrevidenciario/index.vue'
import CTransacaoPrevidenciario from './CTransacaoPrevidenciario/index.vue'
import CSubvencaoIRPJCSLL from './CSubvencaoIRPJCSLL/index.vue'
import CSubvencaoPISCOFINS from './CSubvencaoPISCOFINS/index.vue'
import CIcmsDifalPisCofins from './CIcmsDifalPisCofins/index.vue'
import CHorasExtras from './CHorasExtras/index.vue'
import CRatReducao from './CRatReducao/index.vue'
import CCoeficientePresuncao from './CCoeficientePresuncao/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faRotateRight,
	faCirclePlus,
	faImage,
} from '@fortawesome/free-solid-svg-icons'
import {
	faLinkedinIn,
	faInstagram,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons'

import Chart from 'chart.js/auto'
import { genId } from '@/helpers/gen-id'
import { sleep } from '@/helpers/sleep'
import { currencyFormat } from '@/helpers/currency-format'
import api from '@/helpers/fetch'
import html2canvas from 'html2canvas'
import store from '@/store/store.js'
import pdf from './pdf'

library.add(
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faRotateRight,
	faCirclePlus,
	faLinkedinIn,
	faInstagram,
	faYoutube,
	faImage,
)
let chart
let rChart

@Component({
	components: {
		Loader,
		CalcSelectionModal,
		CIcms,
		CIss,
		CIssPis,
		CPisIss,
		CPisIcms,
		CPis,
		CCide,
		CPerse,
		CJovem,
		CServicosHospitalares,
		CJcp,
		CJcpTlp,
		CPat,
		CRemuneracaoAdm,
		CCreditosPisCofins,
		CTransacaoNaoPrevidenciario,
		CTransacaoPrevidenciario,
		CSubvencaoIRPJCSLL,
		CSubvencaoPISCOFINS,
		CIcmsDifalPisCofins,
		CHorasExtras,
		CRatReducao,
		CCoeficientePresuncao,
	},
	async beforeRouteEnter(to, from, next) {
		// chamando qualquer endpoint para bloquear acesso externo
		const res = await api.get('/api/systems')
		next()
	},
})
export default class Calculator extends Vue {
	calcs = [] as Array<any>
	tabIndex = 0
	printing = false
	pdfLoading = false
	pngLoading = false
	renderImage = false
	documentTitle = ''

	form = {
		company: '',
		companyContact: '',
		lawyer: '',
		lawyerContact: '',
		obs: '',
	}

	imageForm = {
		disclaimer: true,
		rchart: false,
		chart: false,
		table: true,
		cards: true,
		date: true,
		logo: true,
		title: true,
		filename: '',
	}

	chartImg = {
		monthly: '',
		recuperate: '',
	}

	modal = {
		options: [
			{
				name: 'Exclusão do ICMS-ST da base do PIS e da Cofins',
				component: 'c-icms',
				label: 'Exclusão ICMS bc PIS',
				color: '#b15928',
				id: genId(),
				infoId: 35,
				groupId: 0,
			},
			{
				name: 'Exclusão do ISS da base do PIS e da Cofins',
				component: 'c-iss-pis',
				label: 'Exclusão ISS bc PIS',
				color: '#1f78b4',
				id: genId(),
				infoId: 2,
				groupId: 0,
			},
			{
				name: 'Exclusão do PIS e Cofins da base do ISS',
				component: 'c-pis-iss',
				label: 'Exclusão PIS bc ISS',
				color: '#46594f',
				id: genId(),
				infoId: 3,
				groupId: 3,
			},
			{
				name: 'Exclusão do PIS e Cofins da base do ICMS',
				component: 'c-pis-icms',
				label: 'Exclusão PIS bc ICMS',
				color: '#418c12',
				id: genId(),
				infoId: 120,
				groupId: 4,
			},
			{
				name: 'Exclusão do PIS e da Cofins da própria base',
				component: 'c-pis',
				label: 'Exclusão PIS pp bc',
				color: '#b2df8a',
				id: genId(),
				infoId: 4,
				groupId: 0,
			},
			{
				name: 'Exclusão do ICMS-Difal da base do PIS e da Cofins',
				component: 'CIcmsDifalPisCofins',
				label: 'Exclusão do ICMS-Difal do PIS e da Cofins',
				color: '#fc0303',
				id: genId(),
				infoId: 145,
				groupId: 0,
			},
			{
				name: 'Exclusão do ISS da Própria Base',
				component: 'c-iss',
				label: 'Exclusão ISS pp bc',
				color: '#ffff99',
				id: genId(),
				infoId: 5,
				groupId: 3,
			},
			/* tema já julgado
			{
				name: 'Não incidência de PIS e Cofins sobre Selic',
				component: 'c-selic-pis',
				label: 'Selic bc PIS',
				color: '#5F4BB6',
				id: genId(),
				infoId: 6,
				groupId: 0,
			},
			*/
			/* tema já julgado
			{
				name: 'Sistema S e Terceiros - Limitação 20 salários mínimos',
				component: 'c-sistema-s',
				label: 'Sistema S',
				color: '#33a02c',
				id: genId(),
				infoId: 7,
				groupId: 2,
			},
			*/
			{
				name: 'Incidência da Cide sobre os pagamentos a empresas no exterior',
				component: 'c-cide',
				label: 'CIDE',
				color: '#fb9a99',
				id: genId(),
				infoId: 8,
				groupId: 6,
			},
			/* tema já julgado
			{
				name: 'Majoração da Alíquota do RAT - Ilegalidade do Decreto 6.957/2009',
				component: 'c-rat',
				label: 'RAT',
				color: '#e31a1c',
				id: genId(),
				infoId: 9,
				groupId: 2,
			},
			*/
			/* tema já julgado
			{
				name: 'Energia Elétrica - TUST e TUSD',
				component: 'c-tust-tusd',
				label: 'TUSD/TUST',
				color: '#fdbf6f',
				id: genId(),
				infoId: 10,
				groupId: 4,
			},
			*/
			/* tema já julgado
			{
				name: 'Alíquota Abusiva - Energia Elétrica e Telecom',
				component: 'c-telecom',
				label: 'Alíquota Abusiva',
				color: '#ff7f00',
				id: genId(),
				infoId: 11,
				groupId: 4,
			},
			*/
			/* tema já julgado
			{
				name: 'Não incidência de IRPJ e CSLL sobre Selic',
				component: 'c-csll',
				label: 'IRPJ',
				color: '#cab2d6',
				id: genId(),
				infoId: 12,
				groupId: 1,
			},
			*/
			/* tema já julgado
			{
				name: 'Cota Patronal - Retenções de INSS e IRPF dos empregados',
				component: 'c-patronal',
				label: 'Patronal',
				color: '#6a3d9a',
				id: genId(),
				infoId: 13,
				groupId: 2,
			},
			*/
			/* julgada desfavorável
			{
				name: 'Crédito irrestrito de PIS e Cofins',
				component: 'c-irrestrito',
				label: 'Crédito Irrestrito PIS',
				color: '#E4572E',
				id: genId(),
				infoId: 14,
			},
			*/
			{
				name: 'Direito à alíquota zero - PERSE',
				component: 'c-perse',
				label: 'perse',
				color: '#EFD9CE',
				id: genId(),
				infoId: 15,
				groupId: 6,
			},
			{
				name: 'Aprendiz: Exclusão da Contribuição Patronal',
				component: 'c-jovem',
				label: 'Jovem Aprendiz',
				color: '#A2D729',
				id: genId(),
				infoId: 16,
				groupId: 2,
			},
			{
				name: 'Não incidência de contribuição previdenciária sobre horas extras',
				component: 'c-horas-extras',
				label: 'Horas Extras',
				color: '#141B41',
				id: genId(),
				infoId: 123,
				groupId: 2,
			},
			{
				name: 'Contribuição ao RAT – redução da base de cálculo',
				component: 'c-rat-reducao',
				label: 'RAT',
				color: '#e31a1c',
				id: genId(),
				infoId: 136,
				groupId: 2,
			},
			/* tema já julgado
			{
				name: 'Demanda Contratada - ICMS - Energia Elétrica',
				component: 'c-demanda-ee',
				label: 'Demanda Contratada EE',
				color: '#A44A3F',
				id: genId(),
				infoId: 17,
				groupId: 4,
			},
			*/
			/* julgada desfavorável
			{
				name: 'Correção Monetária - Não incidência de IRPJ e CSLL',
				component: 'c-monetaria-irpj',
				label: 'Correção Monetária IRPJ',
				color: '#141B41',
				id: genId(),
				infoId: 18,
			},
			*/
			/* tema já julgado
			{
				name: 'Correção Monetária - Não incidência de PIS e Cofins',
				component: 'c-monetaria-pis',
				label: 'Correção Monetária PIS',
				color: '#A7D3A6',
				id: genId(),
				infoId: 19,
				groupId: 0,
			},
			*/
			{
				name: 'Serviços hospitalares e coeficiente de tributação no Lucro Presumido',
				component: 'c-servicos-hospitalares',
				label: 'Serviços Hospitalares',
				color: '#FF5C74',
				id: genId(),
				infoId: 20,
				groupId: 1,
			},
			{
				name: 'Lucro Presumido - Majoração do coeficiente de presunção',
				component: 'c-coeficiente-presuncao',
				label: 'Coeficiente de Presunção',
				color: '#FF745C',
				id: genId(),
				infoId: 154,
				groupId: 1,
			},
			{
				name: 'JCP retroativo - Dedução da base do IRPJ e da CSLL',
				component: 'c-jcp',
				label: 'JCP',
				color: '#4C5760',
				id: genId(),
				infoId: 21,
				groupId: 1,
			},
			/*
			{
				name: 'Crédito de PIS e Cofins sobre insumos relevantes e essenciais',
				component: 'c-insumos',
				label: 'Insumos',
				color: '#E4572E',
				id: genId(),
				infoId: 27,
				groupId: 0,
			},
			*/
			{
				name: 'JCP – Utilização da TLP como índice de cálculo',
				component: 'c-jcp-tlp',
				label: 'JCP - TLP',
				color: '#D7F9F1',
				id: genId(),
				infoId: 110,
				groupId: 1,
			},
			{
				name: 'Dedução das despesas com o benefício do PAT',
				component: 'c-pat',
				label: 'Deduções PAT',
				color: '#4E6E5D',
				id: genId(),
				infoId: 30,
				groupId: 1,
			},
			{
				name: 'Remuneração de Administradores e Conselheiros: Dedução da base de cálculo do IRPJ',
				component: 'c-remuneracao-adm',
				label: 'Remuneração Adm',
				color: '#AEF6C7',
				id: genId(),
				infoId: 112,
				groupId: 1,
			},
			//Antiga Créditos PIS/Cofins
			{
				name: 'Crédito de PIS e Cofins sobre insumos relevantes e essenciais',
				component: 'c-creditos-pis-cofins',
				label: 'Crédito PIS/Cofins',
				color: '#2B4570',
				id: genId(),
				infoId: 27,
				groupId: 0,
			},
			{
				name: 'Transação Tributária - Não Previdenciária',
				component: 'c-transacao-nao-previdenciario',
				label: 'Transação Não Previdenciária',
				color: '#FE7F2D',
				id: genId(),
				infoId: 116,
				groupId: 5,
			},
			{
				name: 'Transação Tributária - Previdenciária',
				component: 'c-transacao-previdenciario',
				label: 'Transação Previdenciária',
				color: '#BABD8D',
				id: genId(),
				infoId: 117,
				groupId: 5,
			},
			{
				name: 'Subvenção - Exclusão da base do IRPJ e CSLL',
				component: 'c-subvencao-IRPJ-CSLL',
				label: 'Subvenção-IRPJ-CSLL',
				color: '#AA8077',
				id: genId(),
				infoId: 28,
				groupId: 1,
			},
			{
				name: 'Subvenção - Exclusão da base do PIS e Cofins',
				component: 'c-subvencao-PIS-COFINS',
				label: 'Subvenção-PIS-Cofins',
				color: '#AA77A8',
				id: genId(),
				infoId: 29,
				groupId: 0,
			},
		],
	}

	get isCollaborator() {
		return store.user.isCollaborator
	}

	get user() {
		return store.user
	}

	pushCalc(option) {
		this.calcs.unshift({
			component: option.component,
			label: option.label,
			color: option.color,
			savings: 0,
			recuperate: 0,
			id: genId(),
			infoId: option.infoId,
		})
		this.$router.push({ hash: '' })

		const win: any = window
		if (win.gtag) {
			const user = JSON.parse(localStorage.getItem('user') || '')
			win.gtag('event', 'calculadora_adicionada', {
				identificador_usuario: 'id-' + user?.id,
				nome_calculadora: option?.name,
			})
		}
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	removeCalc(calc, index) {
		let indexEach = 0
		for (indexEach; indexEach < this.calcsEach.length; indexEach++) {
			if (this.calcsEach[indexEach].id === calc.id) break
		}

		this.calcsEach.splice(indexEach, 1)
		this.$store.dispatch('setCalcsEach', this.calcsEach)

		let indexPrint = 0
		for (indexPrint; indexPrint < this.calcsPrint.length; indexPrint++) {
			if (this.calcsPrint[indexPrint].id === calc.id) break
		}

		this.calcsPrint.splice(indexPrint, 1)

		this.calcs.splice(index, 1)
	}

	openModal() {
		this.$router.push({ hash: '#add-calc' })
	}

	removeHash() {
		if (this.$route.hash === '#add-calc') {
			this.$router.push({ hash: '' })
		}
	}

	clearCalcs() {
		this.calcs.splice(0, this.calcs.length)
		this.$store.dispatch('setCalcsEach', [])
		this.$store.dispatch('setCalcsPrint', [])
	}

	updateChart() {
		chart.data.datasets = []
		this.calcs.forEach((calc) => {
			if (Array.isArray(calc.savings)) {
				calc.savings.forEach((saving) => {
					chart.data.datasets.push({
						maxBarThickness: 110,
						label: calc.label,
						data: [saving],
						backgroundColor: calc.color,
					})
				})
			} else {
				chart.data.datasets.push({
					maxBarThickness: 110,
					label: calc.label,
					data: [calc.savings],
					backgroundColor: calc.color,
				})
			}
		})
		chart.update()

		rChart.data.datasets = []
		this.calcs.forEach((calc) => {
			if (Array.isArray(calc.recuperate)) {
				calc.recuperate.forEach((recuperate) => {
					rChart.data.datasets.push({
						maxBarThickness: 110,
						label: calc.label,
						data: [recuperate],
						backgroundColor: calc.color,
					})
				})
			} else {
				rChart.data.datasets.push({
					maxBarThickness: 110,
					label: calc.label,
					data: [calc.recuperate],
					backgroundColor: calc.color,
				})
			}
		})
		rChart.update()
	}

	getPrintHtmlCalc(id) {
		const elem = document.getElementById(id)
		// talvez o elemento nao tenha sido montado ainda
		if (!elem) return ''

		const copy = elem.cloneNode(true) as HTMLElement
		while (copy!.querySelector('.d-print-none') !== null) {
			copy.querySelector('.d-print-none')!.remove()
		}

		copy.querySelector('.d-none')!.classList.remove('d-none')

		return copy.outerHTML
	}

	get printableCalcs() {
		//this.renderCharts()

		const ids = this.calcs.map((calc) => calc.id)
		let html = ''
		for (let i = 0; i < ids.length; i++) {
			html += this.getPrintHtmlCalc(ids[i])
		}

		return html
	}

	getPrintableTable() {
		const elem = document.getElementById('table-resumo')
		if (!elem) return ''

		const copy = elem.cloneNode(true) as HTMLElement
		return copy.outerHTML
	}

	get totalSavings() {
		const total = this.calcsPrint.reduce(function (sum, calc) {
			if (calc.type !== 'table') return sum
			return (
				sum +
				parseFloat(
					calc.savings.replaceAll('.', '').replaceAll(',', '.'),
				)
			)
		}, 0)
		return currencyFormat(total)
	}

	get totalRecuperate() {
		const total = this.calcsPrint.reduce(function (sum, calc) {
			if (calc.type !== 'table') return sum
			return (
				sum +
				parseFloat(
					calc.recuperate.replaceAll('.', '').replaceAll(',', '.'),
				)
			)
		}, 0)
		return currencyFormat(total)
	}

	get tableCalcs() {
		return this.calcsPrint.map((calc) => {
			return {
				tese: calc.title,
				color: calc.color,
				savings: calc.savings,
				recuperate: calc.recuperate,
			}
		})
	}

	async renderCharts() {
		// salva aba inicial
		const currentTab = this.tabIndex
		// troca de aba do chart
		this.tabIndex = currentTab === 0 ? 1 : 0
		// espera renderizar
		await sleep(1000)
		// volta pra aba inicial
		this.tabIndex = currentTab
		// @ts-ignore
		this.chartImg.monthly = this.$refs.chart.toDataURL()
		// @ts-ignore
		this.chartImg.recuperate = this.$refs.rchart.toDataURL()
	}

	async downloadPng() {
		this.pngLoading = true
		const div = document.createElement('div')
		div.style.position = 'absolute'
		div.style.top = '-9999999px'
		div.innerHTML = (
			document
				.getElementById('calc-page-print')!
				.cloneNode(true) as HTMLElement
		).innerHTML
		document.body.appendChild(div)

		const onePageCanvas = document.createElement('canvas')
		onePageCanvas.setAttribute('width', div.clientWidth * 1.1 + 'px')
		onePageCanvas.setAttribute('height', div.clientHeight + 'px')
		const ctx = onePageCanvas.getContext('2d')
		const printCalcsCanvas = await html2canvas(div)

		ctx!.drawImage(printCalcsCanvas, 0, 0)
		if (this.imageForm.logo) {
			const dim = div.querySelector('.png-logo')!.getBoundingClientRect()
			// adiciona a imagem do logo manualmente agora com as dimensoes corretas
			ctx!.drawImage(
				this.$refs.pngLogo as HTMLImageElement,
				dim.x,
				9999999 + dim.y,
				150,
				46,
			) // dim.y é negativo;
		}

		div.remove()
		// document.body.appendChild(onePageCanvas);
		// Create a link
		const aDownloadLink = document.createElement('a')
		// Add the name of the file to the link
		aDownloadLink.download = this.imageForm.filename
			? this.imageForm.filename + '.png'
			: 'locatelli-estimativa.png'
		// Attach the data to the link
		aDownloadLink.href = onePageCanvas.toDataURL()
		// Get the code to click the download link
		aDownloadLink.click()
		this.pngLoading = false
	}

	@Watch('$route.hash')
	loadHash() {
		if (this.$route.hash) {
			this.$nextTick(() => {
				if (this.$route.hash === '#add-calc') {
					this.$bvModal.show('modal-calcs')
				} else if (this.$route.hash === '#reset') {
					this.clearCalcs()
					this.$router.push({ hash: '' })
				}
			})
		} else {
			this.$bvModal.hide('modal-calcs')
		}
	}

	async print() {
		this.pdfLoading = true
		//this.renderCharts()
		await sleep(1500)
		pdf.clear()
		/*
		pdf.setUser(
			this.user.name,
			this.user.email,
			this.form.lawyerContact,
			this.form.obs,
		)
		*/
		pdf.setClient(this.form.company, this.form.companyContact)

		this.calcsPrint.forEach((calc) => {
			pdf.addCalc(calc)
		})

		pdf.download()
		this.pdfLoading = false
	}

	mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		this.documentTitle = document.title
		window.addEventListener('afterprint', (event) => {
			document.title = this.documentTitle
		})
		window.addEventListener('beforeprint', (event) => {
			this.documentTitle = document.title
			document.title =
				'Estimativa de Economia e Recuperação Tributária - ' +
				this.form.company +
				' - Locatelli'
		})

		this.loadHash()

		/*
		this.$nextTick(() => {
			chart = new Chart(this.$refs.chart as any, {
				type: 'bar',
				data: {
					labels: ['Economia Mensal'],
					datasets: [],
				},
				options: {
					scales: {
						y: {
							beginAtZero: true,
						},
					},
				},
			})

			rChart = new Chart(this.$refs.rchart as any, {
				type: 'bar',
				data: {
					labels: ['Recuperação'],
					datasets: [],
				},
				options: {
					scales: {
						y: {
							beginAtZero: true,
						},
					},
				},
			})
		})
		*/
	}
}
